module.exports = __webpack_public_path__ + "img/2020_12_13_rock_rhino.98abbabd.jpg";